export function formatBucketLabel(bucket: string): string {
  if (bucket.length === 7) {
    return new Date(`${bucket}-01`).toLocaleDateString("fr-FR", {
      month: "short",
      year: "2-digit",
    });
  }
  return new Date(bucket).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
}

export function formatXaf(value: number): string {
  return `${value.toLocaleString("fr-FR")} XAF`;
}

export function formatTransactionCount(value: number): string {
  return `${value} transaction${value !== 1 ? "s" : ""}`;
}
